import React from "react";
import { Box } from "@mui/joy";
import type { ViewMode } from "components/common/PlanningCalendar";
import { PlanningControls } from "components/common/PlanningCalendar";
import PlanningLeaveBookingsGrid from "./PlanningCalendarGrid";
import type { PlanningCalendarViewMode } from "../hooks/usePlanningCalendar";

export type PlanningViewContentProps = {
  periodTitle: string;
  viewMode: PlanningCalendarViewMode;
  onPrev: () => void;
  onNext: () => void;
  onToday: () => void;
  onViewModeChange: (mode: PlanningCalendarViewMode) => void;
  filterSlot: React.ReactNode;
  leaveModalSlot: React.ReactNode;
  gridProps: React.ComponentProps<typeof PlanningLeaveBookingsGrid>;
};

export default function PlanningViewContent({
  periodTitle,
  viewMode,
  onPrev,
  onNext,
  onToday,
  onViewModeChange,
  filterSlot,
  leaveModalSlot,
  gridProps,
}: PlanningViewContentProps) {
  return (
    <Box
      sx={{
        p: { xs: 1, sm: 2 },
        height: "100%",
        minHeight: 0,
        overflow: "auto",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <PlanningControls
        viewModes={["week", "month"]}
        periodTitle={periodTitle}
        viewMode={viewMode}
        onPrev={onPrev}
        onNext={onNext}
        onToday={onToday}
        onViewModeChange={(m) => onViewModeChange(m as Exclude<ViewMode, "day">)}
        actionsSlot={filterSlot}
      />
      {leaveModalSlot}
      <PlanningLeaveBookingsGrid {...gridProps} />
    </Box>
  );
}
